<template>
  <div
    :class="[
      'custom-header',
      'custom-header--type' + type,
      { 'custom-header--sticky': sticky },
    ]"
    :style="{
      backgroundColor: bgc,
    }"
  >
    <div class="custom-header-inner">
      <!-- 返回按钮，根据 hasBack 参数决定是否显示 -->
      <div @click="handleBack" v-if="hasBack" class="back clickable">
        <i class="el-icon-arrow-left"></i>
        返回
      </div>
      <!-- 1:一个搜索框 -->
      <div v-if="type === '1'" class="search-box">
        <el-input
          :placeholder="searchPlaceholder"
          v-model="searchValue"
          clearable
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="emitSearch"
          ></el-button>
        </el-input>
      </div>

      <!-- 2:(有标题，有搜索框，有导航栏)-->
      <div v-if="type === '2'">
        <div class="title">{{ title }}</div>
        <div class="search-2">
          <div class="search-box-2" v-if="hasSearch">
            <el-input
              :placeholder="searchPlaceholder"
              v-model="searchValue"
              @keyup.enter.native="emitSearch"
              clearable
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="emitSearch"
              ></el-button>
            </el-input>
          </div>
          <!-- <div v-if="hasPath" class="path" @click="$router.push(path)">
            <img
              v-if="!hasNewClue"
              :src="require('@/img/pc/follow/gofollow.png')"
            />
            <div v-else class="redNotice"></div>
            <div>去接单</div>
          </div> -->
        </div>
      </div>

      <!-- 3:一个小的标题-在左边 -->
      <div v-if="type === '3'" class="title">{{ title }}</div>

      <!-- 4:一个tabs,一个标题，一个副标题 -->
      <div v-if="type === '4'" class="tabs">
        <div class="tab-items">
          <!-- 标签项 -->
          <div
            v-for="tab in tabs"
            :key="tab.id"
            :class="['tab-item', { active: activeTab === tab.id }]"
            @click="handleTabClick(tab.id)"
          >
            {{ tab.name }}
          </div>
        </div>
        <div class="tab-title-box">
          <div class="font34 b">{{ choosedTabItem.title }}</div>
          <div class="font18 c3b5">{{ choosedTabItem.defaultTitle }}</div>
        </div>
      </div>

      <!-- 5:一个大的标题-在中间，有筛选+搜索框 -->
      <div v-if="type === '5'" class="type5-wrapper">
        <div class="title-center">{{ title }}</div>
        <div v-if="hasSearch || hasFilter" class="type5-toolbar">
          <div class="type5-toolbar-right">
            <!-- 筛选按钮 -->
            <div
              v-if="hasFilter"
              class="filter-btn"
              @click="$emit('filter-click')"
            >
              <i class="el-icon-s-operation"></i>
              <span>筛选</span>
            </div>
            <!-- 搜索框 -->
            <div v-if="hasSearch" class="search-box-5">
              <el-input
                v-model="searchValue"
                :placeholder="searchPlaceholder"
                clearable
                @keyup.enter.native="emitSearch"
              >
                <i slot="prefix" class="el-icon-search search-icon"></i>
              </el-input>
            </div>
          </div>
        </div>
      </div>

      <div v-if="type === '6'" class="type6-wrapper">
        <div class="font34 b">{{ title }}</div>
        <div class="font18 c3b5" v-if="defaultTitle">{{ defaultTitle }}</div>
      </div>

      <div v-if="type === '7'" class="type7-wrapper">
        <div class="b" :style="{ fontSize: fontSize }">
          {{ title }}
        </div>
        <div class="font18 c3b5" v-if="defaultTitle">{{ defaultTitle }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageHeader",
  props: {
    //字体大小
    fontSize: {
      type: String,
      default: "34px",
    },
    // 副标题
    defaultTitle: {
      type: String,
      default: "",
    },
    // 类型，1:一个搜索框 2:(有标题，有搜索框，有导航栏) 3:一个标题 4:一个tabs,一个标题，一个副标题
    type: {
      type: String,
      default: "",
    },
    // 标题
    title: {
      type: String,
      default: "",
    },
    // 是否有返回按钮，默认为true
    hasBack: {
      type: Boolean,
      default: true,
    },
    // 返回按钮跳转路径
    backUrl: {
      type: String,
      default: "",
    },
    // 背景颜色
    bgc: {
      type: String,
      default: "",
    },
    // 搜索框占位符
    searchPlaceholder: {
      type: String,
      default: "请输入搜索内容",
    },
    // 是否有搜索框，默认为true
    hasSearch: {
      type: Boolean,
      default: false,
    },
    // 是否显示筛选按钮（仅部分类型使用，例如 type=5）
    hasFilter: {
      type: Boolean,
      default: false,
    },
    // 页面需要滚动时，头部固定在视口顶部
    sticky: {
      type: Boolean,
      default: false,
    },
    // 是否有跳转路径，默认为true
    hasPath: {
      type: Boolean,
      default: true,
    },
    // 跳转路径
    path: {
      type: String,
      default: "",
    },
    // 是否有跟单新线索，默认为false
    hasNewClue: {
      type: Boolean,
      default: false,
    },
    // 当前激活的标签
    activeTab: {
      default: "",
    },
    // 标签列表
    tabs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchValue: "",
    };
  },
  computed: {
    // 选择的标签项
    choosedTabItem() {
      return this.tabs.find((tab) => tab.id === this.activeTab);
    },
  },

  methods: {
    handleBack() {
      // 业务详情可显式指定返回行为，未监听的旧页面保持原有历史返回策略。
      if (this.$listeners.back) {
        this.$emit('back');
        return;
      }
      // 1. 优先使用尝试返回上一页
      const hasPrevPage = window.history.length > 2;
      const referrer = document.referrer;
      const isExternalEntry =
        !referrer || !referrer.includes(window.location.host);
      console.log("hasPrevPage:", hasPrevPage);
      console.log("referrer:", referrer);
      console.log("isExternalEntry:", isExternalEntry);
      if (hasPrevPage && !isExternalEntry) {
        // 有上一页且来源是本站，正常返回
        this.$router.go(-1);
      } else {
        // 2.无上一页或从外部直接进入，返回会脱离项目
        if (this.backUrl) {
          //有backUrl，返回backUrl
          this.$router.replace(this.backUrl);
        } else {
          //没有backUrl，重定向到首页
          this.$router.replace("/home");
        }
      }
    },
    emitSearch() {
      this.$emit("get", this.searchValue);
    },
    // 处理标签点击事件
    handleTabClick(tabName) {
      if (this.activeTab !== tabName) {
        // 触发自定义事件通知父组件
        this.$emit("update:activeTab", tabName);
      }
    },
  },
};
</script>

<style scoped lang="less">
.custom-header {
  display: flex;
  align-items: center;
  // border-top: 1px solid #e8e8e8;
  /* 增强阴影效果：增加模糊半径和不透明度 */
  // box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.1); /* 底部阴影（更明显） */

  // &.custom-header--sticky {
  //   position: sticky;
  //   top: 0;
  //   z-index: 100;
  // }

  .custom-header-inner {
    width: @pc-container-width;
    margin: 0 auto;
    .back {
      margin: 18px auto 0;
      border: none;
      background: transparent;
      color: #666;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 6px;
      cursor: pointer;
      padding: 0;
      &:hover {
        color: #4286f5;
      }
    }
    .search-box {
      width: 300px;
      float: right;
      margin: 13px 0;
    }
    .title {
      font-size: 24px;
      font-weight: 500;
      margin: 24px 0 18px;
    }
    .title-center {
      font-size: 32px;
      font-weight: 700;
      text-align: center;
      margin: 24px 0 18px;
    }
    .type5-wrapper {
      position: relative;
      padding-bottom: 18px;
    }
    .type5-toolbar {
      margin-top: 16px;
      display: flex;
      justify-content: flex-end;
    }
    .type5-toolbar-right {
      display: flex;
      align-items: center;
      gap: 16px;
    }
    .filter-btn {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      padding: 6px 14px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      background: #ffffff;
      font-size: 14px;
      color: #606266;
      cursor: pointer;
      transition: all 0.2s;
      i {
        font-size: 14px;
      }
      &:hover {
        border-color: #4286f5;
        color: #4286f5;
        background: #f4f7ff;
      }
    }
    .search-box-5 {
      width: 320px;
      .search-icon {
        color: #c0c4cc;
      }
    }
    .search-2 {
      margin-bottom: 41px;
      display: flex;
      .search-box-2 {
        width: 590px;
      }
      .path {
        font-size: 20px;
        color: #4286f5;
        display: flex;
        align-items: center;
        gap: 8px;
        margin-left: auto;
        img {
          width: 20px;
          height: 20px;
        }
      }

      .redNotice {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #f95348;
      }
    }
    // 情况4样式
    .tabs {
      margin-top: 14px;
      .tab-items {
        display: flex;
        gap: 72px;
        .tab-item {
          font-size: 16px;
          color: #333;
          cursor: pointer;
          &.active {
            font-size: 18px;
            color: #4286f5;
            font-weight: bold;
          }
        }
      }
      .tab-title-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 12px;
        margin-top: 20px;
        padding-bottom: 20px;
      }
    }
    // 情况6样式
    .type6-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 20px 0 32px;
    }
    // 情况7样式：采购订单宽版表单标题
    .type7-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-bottom: 18px;
      .font34 {
        font-size: 23px;
        line-height: 30px;
        letter-spacing: 0;
      }
    }
  }

  &.custom-header--type7 {
    position: relative;
    top: auto;
    right: auto;
    left: auto;
    z-index: auto;
    padding-top: 22px;
    background: #f5f7fb !important;
    box-shadow: none;
    .custom-header-inner {
      width: min(1320px, calc(100vw - 56px));
    }
  }
}

@media (max-width: 760px) {
  .custom-header.custom-header--type7 {
    .custom-header-inner {
      width: calc(100vw - 24px);
    }
  }
}
</style>
